import React, { useEffect, useState } from 'react'
import { FieldTypes, communicationTypes } from '../../utils/constants'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import useBroadcastGroupsApi from '../../hooks/broadcastGroups/useBroadcastGroupsApi'
import Form from '../common/Form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'
import { useGetUserInfo } from '../../hooks/useGetUserInfo'

export default function CommunicationForm({
  onSubmit,
  handleCancel,
  building,
}) {
  const classes = useStyles()
  const history = useHistory()
  const userInfo = useGetUserInfo()
  const [values, setValues] = useState({})
  const [apartments, setApartments] = useState([])
  const [useBroadcastGroups, setUseBroadcastGroups] = useState(false)
  const [selectedBuilding, setSelectedBuilding] = useState(building)
  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()
  const [{ getApartmentsFromBuildingState }, { getApartmentsFromBuilding }] =
    useApartmentsApi()
  const [{ broadcastGroupsState }, { getBroadcastGroups }] =
    useBroadcastGroupsApi()

  useEffect(() => {
    const fetchData = async () => {
      getBuildings()
      getBroadcastGroups()
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (selectedBuilding) {
      const fetchApartmentsFromBuilding = async () => {
        getApartmentsFromBuilding(selectedBuilding.id)
      }
      fetchApartmentsFromBuilding()
    }

    setApartments([])
  }, [selectedBuilding && selectedBuilding.id])

  return (
    <div className={classes.paper}>
      <ListHeader bigTitle="Nueva comunicación" canCreate={false} />
      <Form
        values={values}
        setValues={setValues}
        fields={[
          {
            type: FieldTypes.TextField,
            label: 'Titulo',
            hint: 'Ingrese un titulo',
            key: 'title',
            errorMessage: 'El titulo es requerido',
          },
          {
            type: FieldTypes.TextField,
            label: 'Contenido',
            hint: 'Ingrese contenido',
            key: 'content',
            errorMessage: 'El contenido es requerido',
          },
          {
            type: FieldTypes.Select,
            id: 'communication-type',
            label: 'Tipo de comunicación',
            hint: 'Seleccione un tipo',
            key: 'type',
            errorMessage: 'El tipo es requerido',
            options: [
              { value: communicationTypes.DELIVERY, label: 'Delivery' },
              { value: communicationTypes.FARMACIA, label: 'Farmacia' },
              { value: communicationTypes.ENCOMIENDA, label: 'Encomienda' },
              { value: communicationTypes.JARDINERO, label: 'Jardinero' },
              { value: communicationTypes.SALUD, label: 'Salud' },
              { value: communicationTypes.ELECTRICISTA, label: 'Electricista' },
              {
                value: communicationTypes.SANITARIO,
                label: 'Servicios de salud',
              },
              { value: communicationTypes.CARPINTERO, label: 'Carpintero' },
              { value: communicationTypes.FLETE, label: 'Flete' },
              { value: communicationTypes.GENERAL, label: 'Otros servicios' },
            ],
          },
          { type: FieldTypes.Switch, label: 'General', key: 'global' },
          {
            type: FieldTypes.Switch,
            label: 'Usar grupos de difusión',
            key: 'useBroadcastGroups',
            onChange: () => setUseBroadcastGroups(!useBroadcastGroups),
          },
          ...(!useBroadcastGroups && !building
            ? [
                {
                  type: FieldTypes.DoubleAutocomplete,
                  autocompletes: [
                    {
                      label: 'Cliente',
                      hint: 'Seleccione un cliente',
                      key: 'building',
                      options: buildingsState.buildings,
                      multiple: false,
                      freeSolo: false,
                      withMargin: true,
                      disabled: values.global,
                      onChange: (value) => {
                        setSelectedBuilding(value)
                      },
                    },
                    {
                      label: 'Unidad',
                      hint: 'Seleccione un apartamento',
                      key: 'apartment',
                      options: getApartmentsFromBuildingState.apartments,
                      multiple: true,
                      freeSolo: false,
                      withMargin: true,
                      disabled: values.global,
                      onChange: (value) => {
                        setApartments(value)
                      },
                    },
                  ],
                },
              ]
            : []),
          ...(!useBroadcastGroups && building
            ? [
                {
                  type: FieldTypes.Autocomplete,
                  label: 'Unidad',
                  hint: 'Seleccione un apartamento',
                  key: 'apartment',
                  options: getApartmentsFromBuildingState.apartments,
                  multiple: true,
                  freeSolo: false,
                  withMargin: true,
                  disabled: values.global,
                  onChange: (value) => {
                    setApartments(value)
                  },
                },
              ]
            : []),
          ...(useBroadcastGroups && broadcastGroupsState.broadcastGroups.data
            ? [
                {
                  type: FieldTypes.Autocomplete,
                  label: 'Grupo de difusión',
                  hint: 'Seleccione un grupo de difusión',
                  key: 'broadcastGroupId',
                  options: broadcastGroupsState.broadcastGroups.data,
                  onChange: (value) => {
                    setUseBroadcastGroups(value)
                  },
                },
              ]
            : []),
        ]}
        handleSubmit={() => {
          onSubmit({
            ...values,
            ...(selectedBuilding && { buildingId: selectedBuilding.id }),
            ...(apartments && { apartments: apartments.map((a) => a.id) }),
            ...(!values.global && { global: false }),
            createdBy: userInfo?.id,
          })
          history.push('/comunicaciones')
        }}
        handleCancel={handleCancel}
      />
    </div>
  )
}
